import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './BusinessServicesComponent.module.scss';
import metadata from './BusinessServicesComponent.metadata.json5';

function BusinessServicesComponent(props) {

    const {
        data: BusinessServicesVM,
        updateWizardData,
        submissionVM,
        BusinessServicesPath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);


    const addBusinessServices = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            BusinessServicesVM.value = BusinessServicesVM.value || []

            const { _xCenter, _dtoName } = BusinessServicesVM;

            const BusinessServicesObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            BusinessServicesVM.pushElement(
                BusinessServicesObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, BusinessServicesVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            BusinessServicesVM.value.splice(index, 1);
            _.set(submissionVM.value, BusinessServicesPath, BusinessServicesVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, BusinessServicesPath, BusinessServicesVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'proSer1') {
                const value = (item && item.proSer1) ? item.proSer1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = BusinessServicesVM.length > 0 && BusinessServicesVM.children[index].proSer1
                    // eslint-disable-next-line security/detect-object-injection
                    ? BusinessServicesVM.children[index].proSer1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.proSer1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                );
            }

            if (path === 'per2') {
                const value = item.per2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.per2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'des3' && !_.isUndefined(item.proSer1) && item.proSer1 === '25Oth') {
                const value = item.des3 ? item.des3 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }




        }, [handleValueChange, translator, BusinessServicesVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`BusinessServicesTable`]: {
            data: BusinessServicesVM.value,
        }

    }), [BusinessServicesVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addBusinessServices,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            BusinessServicesVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [BusinessServicesVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={BusinessServicesVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessServicesComponent.propTypes = wizardProps;
export default withRouter(BusinessServicesComponent);
